import { render, staticRenderFns } from "./PensionCalculatorModal.vue?vue&type=template&id=06b69fc5&scoped=true"
import script from "./PensionCalculatorModal.vue?vue&type=script&lang=js"
export * from "./PensionCalculatorModal.vue?vue&type=script&lang=js"
import style0 from "./PensionCalculatorModal.vue?vue&type=style&index=0&id=06b69fc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b69fc5",
  null
  
)

export default component.exports